import { LocalDate } from '../../../shared/jsr310-localdates/types/local-date.type';

export class JobsFilters {
	date: LocalDate | null = null;
	jobName: string | null = null;

	constructor() {
	}
}